import { Alert, Button, message } from 'antd'
import { PropsWithChildren, FC } from 'react'

import { useSendEmailVerificationMutation } from '~/gql/graphql'

import { BannerSubcategory } from './logic'
import { useBannerContext } from './useBannersContext'

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface VerifyBannerPropsType {}

/**
 * Text for the banner deviates when isPOFeatureEnabled is true
 */
function getBannerText(
    bannerSubcategory: BannerSubcategory,
    businessAccountName: string,
    email: string,
): { messageText: string; headerText: string } {
    if (bannerSubcategory === BannerSubcategory.PO) {
        return {
            headerText: `Verify your account to join ${businessAccountName}`,
            messageText: `An email was sent to ${email}.  Check your email or resend a verification link to gain access to the Business Account. `,
        }
    } else if (bannerSubcategory === BannerSubcategory.PREMIUM) {
        return {
            headerText: `Verify your account to join ${businessAccountName} on Premium`,
            messageText: `An email was sent to ${email}.  Check your email or resend a verification link to gain access.`,
        }
    }
    // should not fail unless additional bannerSubcategories are added
    throw new Error('attempted to get banner text without a valid bannerType')
}

export const VerifyBanner: FC<
    PropsWithChildren<VerifyBannerPropsType>
> = () => {
    const { userId, bannerSubcategory, businessAccountName, userEmail } =
        useBannerContext()

    const [resendEmailVerification] = useSendEmailVerificationMutation()

    if (!businessAccountName) {
        throw 'Expected business account name to be defined in banner context'
    }

    const { headerText, messageText } = getBannerText(
        bannerSubcategory,
        businessAccountName,
        userEmail,
    )
    const cta = `Resend email verification`

    async function verifyEmail() {
        try {
            await resendEmailVerification({
                variables: {
                    userId,
                },
            })
            message.success('Verification email sent')
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('error sending verification email')
            // eslint-disable-next-line no-console
            console.error(e)
            return null
        }
        return
    }

    return (
        <Alert
            message={headerText}
            description={messageText}
            style={{ marginBottom: '16px', alignItems: 'center' }}
            type={'info'}
            action={<Button onClick={verifyEmail}>{cta}</Button>}
            onClose={() => {
                return
            }}
            showIcon
            closable={false}
        />
    )
}

export default VerifyBanner
